const TOGGLE_FEEDBACK = 'ADD_TO_CART_FEEDBACK/TOGGLE_FEEDBACK';

// =======
// REDUCER
// =======
const initialState = {
  // Add to Cart Feedback is visible or not
  lastAddedProduct: null,
  showAddToCartFeedback: false
};

export const addToCartFeedbackReducerKey = 'addToCartFeedback';

export const addToCartFeedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_FEEDBACK:
      return {
        ...state,
        lastAddedProduct: action.payload,
        showAddToCartFeedback: !state.showAddToCartFeedback
      };
    default:
      return state;
  }
};

// =========
// SELECTORS
// =========
export const getShowAddToCartFeedback = state => {
  return state[addToCartFeedbackReducerKey].showAddToCartFeedback;
};

export const getLastAddedProduct = state => {
  return state[addToCartFeedbackReducerKey].lastAddedProduct;
};

/**
 * Toggle add to cart feedback.
 */
export const toggleAddToCartFeedback = product => ({
  type: TOGGLE_FEEDBACK,
  payload: product
});
